module.exports = __webpack_public_path__ + "static/media/icon-menu.8f3a9185.svg";